export const SET_RESULTS = "SET_RESULTS"
export const SET_ACTIVE_SPACE = "SET_ACTIVE_SPACE"
export const SET_HOLIDAYS = "SET_HOLIDAYS"
export const SET_PROGRESS = "SET_PROGRESS"
export const INVALID_RESULTS = "INVALID_RESULTS"
export const SET_OPERATING_HOURS = "SET_OPERATING_HOURS"
